/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} General_ErrorInputs */

const en_general_error = /** @type {(inputs: General_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An error has occurred`)
};

const de_general_error = /** @type {(inputs: General_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Fehler ist aufgetreten`)
};

/**
* | output |
* | --- |
* | "An error has occurred" |
*
* @param {General_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const general_error = /** @type {((inputs?: General_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_general_error(inputs)
	return de_general_error(inputs)
});